import { Type } from "class-transformer";
import { DhcEvaluatedExpression } from "./DhcEvaluatedExpression";
import { DhcParsed } from "./DhcParsed";

export class DhcEvaluated extends DhcParsed {
    result: any;
    @Type(() => DhcEvaluatedExpression)
    evaluatedExpressions: DhcEvaluatedExpression[];
}
